<template>
	<div class="text-left">
		<div v-if="locations.length > 0">
			<div>
				<div class="left">
					<span class="active-page-title">Solar PV plants list</span>
				</div>
				<ImportButton :error_callback="update_alert" class="right" />
				<div v-if="export_locations" class="right m-r">
					<JsonCSV :data="export_locations" :name="export_csv_name">
						<CustomButton
							text="Export locations"
							:inverse="true"
							previous_icon="arrow-up"
						/>
					</JsonCSV>
				</div>

				<div class="clear"></div>
			</div>

			<div v-if="alert" class="clear p-t">
				<div class="alert">
					<div>
						<span>An error occurred: </span>
						<span>{{ alert }}</span>
						<div class="alert-close" v-on:click="alert = undefined">
							<font-awesome-icon
								style="cursor:pointer"
								size="lg"
								icon="times"
							/>
						</div>
					</div>
				</div>
			</div>

			<div id="locations-row-header" class="locations-row clear">
				<div>
					<span>Name</span>
				</div>
				<div>
					<span>PV category</span>
				</div>
				<div>
					<span>Peak power (MWp)</span>
				</div>
				<div>
					<span>Tracking system</span>
				</div>
				<div>
					<span>Azimuth (º)</span>
				</div>
				<div>
					<span>Tilt</span>
				</div>
				<div>
					<span>Losses (%)</span>
				</div>
				<div>
					<span></span>
				</div>
				<div class="clear"></div>
			</div>

			<Location
				v-for="(location, index) in locations"
				v-bind:key="'locations_list_' + index"
				:location="location"
				:location_key="index"
			></Location>
		</div>

		<div v-else class="no-locations-div relative m-t">
			<NoLocations />
		</div>
	</div>
</template>

<script>
import NoLocations from "@/components/sub-components/NoLocations";
import ImportButton from "@/components/new-location/ImportButton";
import Location from "@/components/pages/sub-components/Location";
import CustomButton from "@/components/sub-components/CustomButton";
import JsonCSV from "vue-json-csv";
import LocationsExportImportService from "@/services/LocationsExportImportService";
var moment = require("moment");

export default {
	name: "Locations",
	components: {
		NoLocations,
		Location,
		CustomButton,
		JsonCSV,
		ImportButton
	},
	data: function() {
		return {
			alert: undefined
		};
	},
	methods: {
		update_alert: function(error) {
			this.alert = error;
		}
	},
	computed: {
		locations: function() {
			return this.$store.getters.locations;
		},
		export_locations: function() {
			if (this.locations.length) {
				return LocationsExportImportService.export_locations(this.locations);
			} else {
				return null;
			}
		},
		export_csv_name: () => {
			return (
				"Solar_Forecasting_locations_" + moment().format("YYYY-MM-DD") + ".csv"
			);
		}
	}
};
</script>

<style>
.active-page-title {
	font-weight: bold;
	font-size: 25px;
	color: white;
}
.locations-row {
	width: 100%;
	color: white;
	border-bottom: 1px solid #dfe3ea;
	padding: 10px 0;
	float: left;
	clear: left;
	margin-top: 25px;
}
#locations-row-header {
	color: #6962e4;
}
#locations-row-header span {
	color: #acacac;
	font-size: 16px;
	font-weight: 500;
}
.locations-row > div {
	float: left;
	overflow-x: hidden;
	min-height: 1px;
}
.locations-row > div:first-child {
	width: calc(22% - 30px);
}
.locations-row > div:nth-child(2) {
	width: 14%;
}
.locations-row > div:nth-child(3) {
	width: 14%;
	text-align: center;
}
.locations-row > div:nth-child(4) {
	width: 14%;
	text-align: center;
}
.locations-row > div:nth-child(5) {
	width: 12%;
	text-align: center;
}
.locations-row > div:nth-child(6) {
	width: 12%;
	text-align: center;
}
.locations-row > div:nth-child(7) {
	width: 12%;
	text-align: center;
}
.locations-row > div:nth-child(8) {
	width: 30px;
}
</style>
